import { useApiQuery } from "../../../../../../common/infrastructure/hooks/useApiQuery";
import { useApiMutation } from "../../../../../../common/infrastructure/hooks/useApiMutation";
import { endpointsMetadata } from "../../../../../../common/infrastructure/routes/endpointsMetadata";
import { IStudioQrCode } from "../models/studioQrCodeModels";
import { IStudioQrCodeFormModel } from "../models/studioQrCodeFormModel";

export const useStudioQrCodes = (studioId: number) => {
  const listKey = [endpointsMetadata.studioQrCode.getAll, studioId];

  const {
    data: qrCodes,
    isLoading,
    isFetching,
  } = useApiQuery<IStudioQrCode[]>({
    queryKey: listKey,
    endpoint: `${endpointsMetadata.studioQrCode.getAll}?studioId=${studioId}`,
    enabled: studioId > 0,
    globalIsLoading: false,
  });

  const { mutate: mutateSave, isLoading: isSaving } = useApiMutation();
  const { mutate: mutateDelete, isLoading: isDeleting } = useApiMutation();
  const { mutate: mutateTransfer, isLoading: isTransferring } = useApiMutation();

  const saveQrCode = (values: IStudioQrCodeFormModel, onDone?: () => void) => {
    const isEdit = !!values.id && values.id > 0;

    mutateSave(
      {
        endpoint: isEdit
          ? endpointsMetadata.studioQrCode.update
          : endpointsMetadata.studioQrCode.create,
        method: isEdit ? "put" : "post",
        queryParams: { studioId },
        payload: {
          id: values.id ?? 0,
          name: values.name,
          destinationUrl: values.destinationUrl,
          isActive: values.isActive,
        },
        invalidateKeys: [listKey],
        successMessage: isEdit
          ? "QR кодът беше запазен успешно."
          : "QR кодът беше създаден успешно.",
      },
      { onSuccess: () => onDone?.() },
    );
  };

  const deleteQrCode = (id: number) => {
    mutateDelete({
      endpoint: endpointsMetadata.studioQrCode.delete,
      method: "delete",
      queryParams: { studioId, itemId: id },
      invalidateKeys: [listKey],
      successMessage: "QR кодът беше премахнат успешно.",
    });
  };

  const transferQrCode = (
    qrCodeId: number,
    targetStudioId: number,
    onDone?: () => void,
  ) => {
    mutateTransfer(
      {
        endpoint: endpointsMetadata.studioQrCode.transfer,
        method: "post",
        queryParams: { studioId },
        payload: { qrCodeId, targetStudioId },
        invalidateKeys: [listKey],
        successMessage: "QR кодът беше прехвърлен успешно.",
      },
      { onSuccess: () => onDone?.() },
    );
  };

  return {
    qrCodes: qrCodes ?? [],
    isLoading: isLoading || isFetching,
    isSaving,
    isDeleting,
    isTransferring,
    saveQrCode,
    deleteQrCode,
    transferQrCode,
  };
};
